import { useTranslation } from 'react-i18next';
import { stringToNumber, isString } from '../../../../../../../../helpers';
import { useRootSelector } from '../../../../../../../../store/hooks';
import { selectSitePricingProductsData } from '../../../../../../store/features/products';
import { getVatMessageKey } from '../../../../../../helpers/selectPackage/getVatMessageKey';
import Typography, {
  TypographyProps,
} from '../../../../../../shared/library/Typography';

export interface VatMessageProps extends TypographyProps {
  vatAmount?: string;
  shortFormat?: boolean;
}

export default function VatMessage(props: VatMessageProps) {
  const { vatAmount, shortFormat, ...restTypographyProps } = props;
  const { t } = useTranslation();
  const {
    priceInclVat: isPriceInclVat,
    taxLabelStyle: vatLabel,
    vatRate,
  } = useRootSelector(selectSitePricingProductsData);
  const vatRateValue = isString(vatRate) ? stringToNumber(vatRate) : vatRate;

  if (vatRateValue <= 0) {
    return null;
  }

  const translationKey = getVatMessageKey({
    shortFormat,
    isPriceInclVat,
    vatLabel,
  });

  return (
    <Typography
      variant="caption2"
      neutralColorIndex={400}
      {...restTypographyProps}
    >
      (
      {t(translationKey, {
        vatRate: vatRateValue,
        vatLabel,
        vatAmount,
      })}
      )
    </Typography>
  );
}
